<register-modal>
    <div id="{ props.modalId }" class="modal js-modal">
        <div class="modal__bg js-modal-close"></div>
        <div class="modal__content modal_filter">
            <div class="modal__content_inner">
                <h2 class="modal_title">chiyo-co利用規約</h2>
                <div style="max-height:300px;overflow-y: scroll">
                    <rules-tag></rules-tag>
                </div>
                <div class="checkbox_wrap rules">
                    <input type="checkbox" name="agree" id="agree" class="checkbox-input"><label for="agree" class="checkbox-parts">規約に同意する</label>
                </div>
                <button class="button button-primary" type="button" value="登録する" onclick="{(e)=> register(e)}">登録する</button>
            </div><!--/.modal__content_inner-->
            <a class="btn_close_modal js-modal-close" onclick="{ onClose }" style="cursor:pointer"><img src="/assets/img/common/icn_close_modal.svg" alt="閉じる"></a>
        </div><!--modal__content-->
    </div><!--modal-->
  <script>
    import { api as UserRegisterApi } from "@model/user-register.js";
    import rulesTag from "@tags/rules.riot";

    export default {
        components: {
            "rules-tag": rulesTag
        },
        register(e) {
            let agree = this.root.querySelector("#agree").checked;
            if (!agree) {
                alert("規約に同意して下さい");
                return;
            }
            UserRegisterApi.register(agree);
        },
        onMounted(){
            UserRegisterApi.on('registered', (success, message) => {
                if (!success) {
                    alert(message);
                    this.onClose();
                    return;

                }
                alert(message);
                this.onClose();
                location.href = '/inputs/textarea';
            });
        },
        onClose(e) {
            window.$(this.$(`#${this.props.modalId}`)).fadeOut(100);
        }
    };
  </script>
</register-modal>
